<template>
    <v-card :class="{ 'rounded': !isMobile() }">
        <v-layout
                row
                wrap
                pa-2
        >
            <v-flex xs12 md4>
                <v-subheader
                        :key="titleHeader"
                        class="subheading"
                >
                    {{ titleHeader }}
                </v-subheader>
            </v-flex>
            <v-flex xs12 md4 class="pl-3">
                <v-text-field
                        class="pt-1"
                        v-model="name"
                        :append-icon="search?'close':'search'"
                        @click:append="search = ''"
                        label="Search"
                        single-line
                        hide-details>
<!--                        @keydown.native.escape="search=''"-->
                </v-text-field>
              <v-btn @click="findStartups()">search</v-btn>
            </v-flex>
            <v-flex pl-2 xs12 md4 v-if="showCreateButton || showExportButton">

                <v-layout justify-end>
                    <v-btn class="mr-0" v-if="showExportButton" round depressed color="primary" @click="exportCallback">EXPORT
                        <v-icon right dark>mdi-download</v-icon>
                    </v-btn>
                    <v-btn class="pl-0 ml-0" v-if="showExportButton" flat icon color="primary" @click="showExportMessage=true">
                        <v-icon>
                            mdi-help-circle-outline
                        </v-icon>
                    </v-btn>
                  <v-dialog v-model="showExportMessage" max-width="300">
                    <v-card>
                      <v-card-title class="headline">How Startup Export works:</v-card-title>
                      <v-card-text>
                        The export will include all startups currently displayed on the page. If the page shows 10
                        startups, only those 10 will be exported. To export all startups, increase the number of items
                        displayed per page or select 'All' in the navigation menu "Startups per page".
                        Also, in search mode, only startups matching the search criteria will be exported.
                      </v-card-text>
                      <v-card-actions>
                        <v-btn color="primary" text @click="showExportMessage=false">OK</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                    <v-btn v-if="showCreateButton" round
                           depressed
                           color="success"
                           @click="createCallback({})"
                    >
                        {{ addNewTitle }}
                        <v-icon right dark>
                            add
                        </v-icon>
                    </v-btn>
                </v-layout>
            </v-flex>
        </v-layout>
        <v-list two-line>
            <template v-for="(element, index) in elements">
                <v-divider
                        v-if="element.divider"
                        :inset="element.inset"
                />
                <v-list-tile class="clickable-cursor"
                             v-else
                             :key="element.id"
                >
                    <v-layout row wrap>
                        <v-flex grow>
                            <v-list-tile-content @click="clickCallback(element)">
                                <v-list-tile-title v-html="element.nameToShow"></v-list-tile-title>
                                <v-list-tile-sub-title v-html="element.description"></v-list-tile-sub-title>
                            </v-list-tile-content>
                        </v-flex>
                        <v-flex shrink v-if="element.nameToShow !== 'None'">
                            <v-btn
                                    small
                                    round
                                    icon
                                    color="red"
                                    class="white--text"
                                    @click="deleteCallback(element)"
                            >
                                <v-icon small dark>
                                    close
                                </v-icon>
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-list-tile>
            </template>
        </v-list>

        <v-dialog
                v-model="showScoreTables"
                max-width="85%"
        >
            <v-card>
                <v-card-title class="headline">How to calculate the score </v-card-title>
                <v-card-text>
                    <ScoreTables></ScoreTables>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
    import ScoreTables from "@/pages/Admin/Innovation/StartupManagement/ScoreTables";
    import UrlsService from "@/helpers/UrlsService";
    import TimeService from "@/helpers/TimeService";
    import APILoaderDecoratorService from "@/helpers/APILoaderDecoratorService";

    export default {
        name: "List",
        components: {ScoreTables},
        //props: ["elements", "titleHeader", "addNewTitle", "createCallback", "clickCallback", "deleteCallback"],
        props: {
            elements:{
                type: Array
            },
            approved: Number,
            titleHeader:{
                type: String
            },
            addNewTitle:{
                type: String
            },
            createCallback:{
                type: Function
            },
            exportCallback:{
                type: Function
            },
            clickCallback:{
                type: Function
            },
            deleteCallback:{
                type: Function
            },
            showCreateButton:{
                type: Boolean,
                default: true
            },
            showExportButton:{
                type: Boolean,
                default: false
            }
        },
        computed: {
            filteredItems() {
                let filtered = [];
                for (let i=0; i<this.elements.length; i=i+2){
                    if(this.elements[i].nameToShow.toLowerCase().includes(this.search.toLowerCase())){
                        filtered.push(this.elements[i]);
                        filtered.push(this.elements[i+1]);
                    }
                }
                filtered.pop();
                return filtered;
            }
        },
        data() {
            return {
                showExportMessage: false,
                showScoreTables: false,
                search: '',
                name: '',
                startupsFound: [],
                initialPage: 0
            }
        },
        created() {
          this.findStartups();
        },
        methods: {
            /*showExportMessage() {
              alert("ciao");
            },*/
            isMobile() {
                return this.$vuetify.breakpoint.name === "xs";
            },
          findStartups() {
              this.$emit("startup-page", this.initialPage);
              this.$emit("startup-search", this.name);
          }
        }
    }
</script>

<style scoped>
    .clickable-cursor{
        cursor: pointer;
    }
</style>